/* eslint-disable */
<template>
  <div class="full-width">
    <el-table
      :data="playlists.data"
      :max-height="maxHeight"
      @sort-change="sortChange"
      :header-cell-class-name="sortClasses"
    >
      <el-table-column
      align="center"
      width="75">
        <template slot-scope="scope">
          <ActionMenu
            :playlist='scope.row'
            :menu='"playlist"'
            :actionColumn='false'
            :handlePopoverShow="handlePopoverShow">
          </ActionMenu>
        </template>
      </el-table-column>
      <el-table-column
      align="center"
      width="50"
      v-if="isSchoolUser"
      >
        <template slot-scope="scope">
          <Tooltip v-if="scope.row.teachers[0].playlistTeacher.playlistRole === 2" top>
            <v-icon>create</v-icon>
            <template v-slot:text>
              You are a Co-Owner of this playlist.
            </template>
          </Tooltip>
          <Tooltip v-else-if="scope.row.teachers[0].playlistTeacher.playlistRole === 3" top>
            <v-icon>remove_red_eye</v-icon>
            <template v-slot:text>
              You are a Facilitator of this playlist.
            </template>
          </Tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="Playlist Name"
        prop="name"
        sortable="custom"
      >
        <template slot-scope="scope">
          <div class='row-start'>
            <Tooltip
              v-if="passbackLinking"
              top
              style="margin-right: 5px;">
              <v-btn
                tabindex="1"
                icon
                @click="passbackContent({playlistId: scope.row.id, playlistName: scope.row.name, type: 'playlist'})"
                :aria-label="`Click to passback playlist ${scope.row.name} to module`">
                <v-icon
                  class="selectable bulbPickerIcon">
                  exit_to_app
                </v-icon>
              </v-btn>
              <template v-slot:text>
                Select Playlist
              </template>
            </Tooltip>
            <Tooltip 
              v-if="LTIlaunch && LTIdata.contentId === null" 
              top
            >
              <img 
                @click="handleDialogOpen({ type: 'lti', data: { ...scope.row, type: 'playlist'} })" 
                class="lms-img selectable" 
                :src="LMSdata.img || 'https://cdn.playposit.com/image-uploads/image-22-05-2019-15-35-00--lms_default.png'">
              <template v-slot:text>
                Link Playlist
              </template>
            </Tooltip>
            <Tooltip 
              v-if="LTIlaunch && LTIdata.render_path === 'playlist' && LTIdata.contentId === scope.row.id"   
              top>
                <img 
                  @click="setDashModal({ type: 'confirmUnlink' })"
                  class="lms-img selectable"
                  :src="LMSdata.img || 'https://cdn.playposit.com/image-uploads/image-22-05-2019-15-35-00--lms_default.png'">
              <template v-slot:text>
                Unlink Playlist
              </template>
            </Tooltip>
            <Tooltip top>
              <span
                class="pl-2"
                :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]"
                :ref="scope.row.id">
                {{scope.row.name}}
              </span>
              <template v-slot:text>
                {{scope.row.name}}
              </template>
            </Tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop=""
        label="Tags"
        >
        <template slot-scope="scope">
          <div>
            <div
              class="bulbs-tag-container justify-center"
              v-if="updateTags && scope.row.playlistTags.length > 0">
              <el-tag
                v-for="(tag, index) in rowTags(scope.row)"
                :key="index"
                :style="tagStyle(tag)">
                {{ tag.text }}
              </el-tag>
              <div
                class="edit-tags"
                v-if="(
                  (
                    scope.row.playlistTags.length <= 3
                    || (
                      scope.row.playlistTags.length > 3
                      && showAllTags[scope.row.id]
                    )
                  )
                  && [1, 2].includes(scope.row.teachers[0].playlistTeacher.playlistRole)
                  && !passbackLinking
                  )">
                <span
                  class="selectable"
                  @click="setDashModal({ type: 'playlistTags', playlist: scope.row })">
                  Edit Tags
                </span>
              </div>
              <el-tag
                @click="showTags(scope.row)"
                v-show="scope.row.playlistTags.length > 3 && !showAllTags[scope.row.id]"
                type="info"
                style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">
                ...
              </el-tag>
              <el-tag
                @click="showTags(scope.row)"
                v-show="scope.row.playlistTags.length > 3 && showAllTags[scope.row.id]"
                type="info"
                style="margin:5px; background-color:#fff; border-color: #fff;"
                class="cursor">
                <v-icon small>
                  clear
                </v-icon>
              </el-tag>
            </div>
            <span
              v-if="(
                scope.row.playlistTags.length === 0
                && [1, 2].includes(scope.row.teachers[0].playlistTeacher.playlistRole)
                && !passbackLinking
              )"
              class="selectable"
              aria-label="Add Tags"
              tabIndex="0"
              @click="setDashModal({ type: 'playlistTags', playlist: scope.row })">
              Add Tags
            </span> 
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Created"
        prop="created"
        sortable="custom"
        align="center"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="100"
        prop=""
        label="Actions">
        <template slot-scope="scope">
          <ActionMenu
            :playlist='scope.row'
            :menu='"playlist"'
            :actionColumn='true'
            :handlePopoverShow="handlePopoverShow">
          </ActionMenu>
        </template>
      </el-table-column>
    </el-table>
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import ActionMenu from '../../ActionMenu';
import _ from 'lodash';
const Color = require('color');

export default {
  name: 'PlaylistTable',
  components: {
    ActionMenu,
  },
  props: [
    'maxHeight',
    'handlePopoverShow',
  ],
  data() {
    return {
      showAllTags: {},
      updateTags: true,
    };
  },
  computed: {
    ...mapState('instructors', [
      'instructorAjaxing',
      'playlists',
      'queryParamsInstructors',
    ]),
    ...mapGetters([
      'instructorData',
      'LMSdata',
      'LTIdata',
      'LTIlaunch',
      'nodeApiPrefix',
      'passbackLinking',
      'school',
      'userAgent',
    ]),
    isSchoolUser() {
      if (_.get(this, 'school.id')) return true;
      return false;
    },
    isSafari() {
      return _.get(this, 'userAgent.browser.name', '').toLowerCase() === 'safari';
    },
  },
  methods: {
    ...mapActions([
      'passbackContent',
    ]),
    ...mapActions('instructors', [
      'getTableData',
      'getPlaylists',
      'updateUrl',
    ]),
    ...mapMutations([  
      'handleDialogOpen',
      'setDashModal',
    ]),
    ...mapMutations('instructors', [
      'setQueryParams',
    ]),
    rowTags(playlist) {
      const filteredTags = [];
      playlist?.playlistTags.forEach((playlistTag, index) => {
        const tagData = {
          hex: playlistTag.tag.hex,
          type: playlistTag.tag.type,
          text: playlistTag.text ? playlistTag.text : playlistTag.tag.value,
        };
        if (
          !this.showAllTags[playlist.id]
          && index <= 2
        ) filteredTags.push(tagData)
        else if (this.showAllTags[playlist.id]) filteredTags.push(tagData);
      });
      return filteredTags;
    },
    setKeywordFilter: function (tag) {
      //reset query params and update url
      this.$store.commit('instructors/setQueryParams', { sort: '', page: 1, per_page: 20, search: '' });
      this.$store.dispatch('instructors/updateUrl');
      let obj = { ...this.filterSearch, legacy: false }
      if (tag.type === 'age') {
        obj.age.push(tag.text);
      } else if (tag.type === 'subject') {
        obj.subject.push(tag.text);
      } else if (tag.type === 'user-generated') {
        obj.keywords.push(tag.text);
      }
      // If you click on the tag, it's implicitly expected that you're looking for that exact tag.
      // So default to always searching for exact match.
      obj.tagExactMatch = true;
      this.$store.commit('instructors/setFilters', obj);
    },
    showTags(row) {
      if (row.playlistTags.length > 3) {
        this.showAllTags[row.id] ? this.showAllTags[row.id] = false : this.showAllTags[row.id] = true;
        this.updateTags = false;
        setTimeout(() => this.updateTags = true, .05);
      }
    },
    sortChange(event) {
      let sortName = this.queryParamsInstructors.sort.split(' ')[0];
      let sortOrder = this.queryParamsInstructors.sort.split(' ')[1];
      if (!this.instructorAjaxing) {
        let queryParams;
        if (
          this.queryParamsInstructors.sort === ''
          && event?.column
        ) {
          // if sort is not set, set sort to column prop ascending
          queryParams = { sort: `${event.prop} ASC` };
        } else if (!event?.column) { // event triggered by keyboardEvent
          const order = event.order === 'ascending' ? 'ASC' : 'DESC';
          queryParams = { sort: `${event.prop} ${order}` };
        } else if (
          event.prop === null
          || (
            event.prop === sortName
            && sortOrder === 'DESC'
          )
        ) {
          queryParams = { sort: '' };
        } else {
          // if sort is set, find name and order
          if (event.prop === sortName) {
            sortOrder = sortOrder === 'ASC' ? 'DESC' : 'ASC';
          } else {
            sortName = event.prop;
            sortOrder = 'ASC';
          }
          queryParams = { sort: `${sortName} ${sortOrder}` }
        }
        // sets query params, calls data, and updates url
        this.setQueryParams(queryParams);
        this.getTableData();
        this.updateUrl();
      }
    },
    // Function to add css classes to columns
    sortClasses(event) {
      if (!this.instructorAjaxing) {
        let sortArray = this.queryParamsInstructors.sort.split(" ");
        //changes header class based on sort
        let sortClass;
        if (_.snakeCase(event.column.property) === sortArray[0]) {
          //returns class based on desc or asc sort to change arrow color
          (sortArray[1] === 'DESC') ? sortClass = 'descSelected' : sortClass = 'ascSelected';
          return sortClass;
        } else {
          // if no sort, return noSelected class
          return 'noSelected';
        }
      }
    },
    tagStyle(data) {
      const color = (data.hex) ? data.hex : '#FAFAFA';
      const darkColor = Color(color).darken(0.60).hex();
      return {
        'backgroundColor': color,
        'color': darkColor,
        'border': `solid 1px ${darkColor}`,
        'borderRadius': '20px',
        'cursor': 'pointer'
      }
    },
  },
  mounted() {
    if (_.get(this.queryParamsInstructors, 'playlistAssign')) {
      const selectedPlaylist = _.find(this.playlists.data, {'id': _.get(this.queryParamsInstructors, 'playlistAssign')});
      if (selectedPlaylist) this.setDashModal({ type: 'playlistAssign', playlist: selectedPlaylist });
    }
  },
};

</script>

<style>
/* Dash z-index is wonky - this ensures the tooltip is above sideNav */
  .v-tooltip__content {
    z-index: 1000 !important;
  }
  .bulbPickerIcon {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
</style>
